module.exports = __webpack_public_path__ + "img/icon4.8040d32c.png";